import { Button } from "@creditonebank/c1b-components";
import { ReactComponent as FailIcon } from "../../assets/Fail.svg";
import { ReactComponent as BadgeIcon } from "../../assets/BadgeIcon.svg";
import React from "react";

const SessionTimedOut = () => {

  const signInWidget = (() => {
    window.location.replace("/")
  })

  return (
    <div className="bg">
      <div className="session-timeout-popup-container">
        <div className="popup-content-container">
          <div className="timer-box">
            <BadgeIcon className="badge" />
            <h4>We signed you out for your security</h4>
            <p className="subtext">We noticed you were inactive for a time. Sign in again to access your account.</p>
          </div>
          <div className="buttons-session-timed-out">
            <Button icon="lock" onClick={signInWidget} className="sign-in">Sign in</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SessionTimedOut